import { render } from "./cp_sch_news.vue?vue&type=template&id=4bb16011&scoped=true"
import script from "./cp_sch_news.vue?vue&type=script&lang=js"
export * from "./cp_sch_news.vue?vue&type=script&lang=js"

import "./cp_sch_news.vue?vue&type=style&index=0&id=4bb16011&scoped=true&lang=css"

import exportComponent from "D:\\Work\\高报云\\代码和文档\\Code\\HZY.Student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bb16011"]])

export default __exports__